<script setup>
import { computed, inject, ref } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import WahaAudioChip from 'next/message/chips/WahaAudio.vue';
import MessageMeta from '../MessageMeta.vue';
import { useMessageContext } from '../provider.js';

const { attachments, sender } = useMessageContext();

const isWaha = inject('isWahaConversation', ref(false));

const attachment = computed(() => {
  return attachments.value[0];
});

const senderThumbnail = computed(() => sender.value?.thumbnail || '');
</script>

<template>
  <BaseBubble
    class="bg-transparent"
    data-bubble-name="audio"
    :hide-meta="isWaha"
  >
    <template v-if="isWaha">
      <WahaAudioChip
        :attachment="attachment"
        :sender-thumbnail="senderThumbnail"
        class="p-1.5 text-n-slate-12 skip-context-menu"
      >
        <template #meta>
          <MessageMeta short-time class="text-n-slate-11" />
        </template>
      </WahaAudioChip>
      <div
        v-if="attachment.transcribedText"
        class="text-n-slate-12 p-2 text-sm rounded-lg w-full break-words bg-n-alpha-black1"
      >
        {{ attachment.transcribedText }}
      </div>
    </template>
    <AudioChip
      v-else
      :attachment="attachment"
      class="p-2 text-n-slate-12 skip-context-menu"
    />
  </BaseBubble>
</template>
